// extracted by mini-css-extract-plugin
module.exports = {"app__header":"N_c5","app__footer":"N_Z","app__flex_row":"N_c6","app__content__list":"N_c7"};